export async function fetchProductImages(props: { siteURL: string, productURL: string }) {
    const headers: Record<string, string> = {};
    headers['referer'] = props.siteURL;

    const productJsonURL = props.siteURL.includes('https') ?
        `${props.siteURL}${props.productURL?.substring(1)?.split('?variant=')[0]}.json` :
        `${props.siteURL.replace('http', 'https')}${props.productURL?.substring(1)?.split('?variant=')[0]}.json`

    const res = await fetch(productJsonURL, headers);
    const data = await res.json();
    const images = data.product.images.map((image: { [key: string]: string | number | object | undefined | boolean }) => image.src);

    return images ?? [];
}

export function getSiteUrl() {
    return window.location.origin + "/"
}